export default __webpack_public_path__ + "static/media/youtube.b51c2d83.svg";